import React from 'react'
import { AddReferralCode as AddReferralCodeIcon } from '@/assets/icons'

export const AddReferralCode = ({
  setShowReferralInput,
  label,
  className,
}: {
  setShowReferralInput: (show: boolean) => void
  label: string
  className?: string
}) => {
  return (
    <button
      type="button"
      onClick={() => setShowReferralInput(true)}
      className={`text-white font-semibold text-sm text-left hover:underline flex items-center gap-[10px] px-[10px] py-[6.5px] ${className}`}
    >
      <AddReferralCodeIcon /> {label}
    </button>
  )
}
